import { Link } from 'react-router-dom'
import { Flex, Image, Text } from 'rebass/styled-components'
import { fmtImageSize } from '../../utils'
import { useQuery } from '@apollo/client'
import { GET_COLLECTIONS } from '../../graphql/queries'

export default ({ collections = [] }) => {
    return (
        <Flex flexWrap="wrap" justifyContent="space-between">
            {collections?.map(({ node }, index) => (
                <Flex width={0.2} justifyContent="center">
                    <Link to={`/category/${node.handle}`}>
                        <Flex
                            key={index}
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            mb="20px"
                            px="5px"
                        >
                            <Image
                                src={fmtImageSize(node.image.src, 50)}
                                width="50px"
                                height="50px"
                                css={{ borderRadius: '50%' }}
                            ></Image>
                            <Text mt="5px" fontSize="12px">
                                {node.title}
                            </Text>
                        </Flex>
                    </Link>
                </Flex>
            ))}
        </Flex>
    )
}
